export default $axios => {   
    return {
        async get() {
            return await $axios.get(`/simulator/favorites`);  
        },
    
        async add(id) {
            return await $axios.post(`/simulator/favorites/${id}`);  
        },
    
        async remove(id) {
            return await $axios.delete(`/simulator/favorites/${id}`);  
        },
    
        async clear() {
            return await $axios.post(`/simulator/favorites/clear`);  
        }
    } 
}; 